import Odometer from "odometer";
import { loadEcho } from 'shared/Echo';

$('#logos').slick({
	// lazyLoad: 'ondemand',
	slidesToShow: Math.floor($('#logos').width() / 150),
	slidesToScroll: 2,
	autoplay: true,
	autoplaySpeed: 2000,
	arrows: false,
	easing: 'ease-in-out',
	infinite: true,
	pauseOnHover: false
});

document.addEventListener('DOMContentLoaded', () => {
	const odometer_element = document.getElementById('lead-odometer');
	const initial_count = odometer_element.dataset.leadCount;
	
	const odometer_animation = new Odometer({
		el: odometer_element,
		duration: 3500,
	});
	
	odometer_animation.update(initial_count - 20);
	
	let initial_spin = setTimeout(() => odometer_animation.update(initial_count), 4000);
	
	loadEcho().then(Echo => {
		Echo.channel('lead-stats')
			.listen('LeadStats', (e) => {
				clearTimeout(initial_spin);
				odometer_animation.update(e.leads);
			});
	});
});
